// Use this with the 'offset-section' class to make the header transparent so that the background image is visible and hover effects are visible.

const header = document.querySelector('sticky-header')

if (header) {
  header.classList.add('header-wrapper--transparent')
}
